import React, { useState, useEffect, useMemo } from 'react';
import {
  useTable,
  useRowSelect,
  usePagination,
  useSortBy,
  useFilters
} from 'react-table';
import Modal from 'react-modal';
import config from '../../config/config';
import axios from 'axios';
import { matchSorter } from 'match-sorter';
import './Table.css';
import DownloadButton from './DownloadButton';

export const AdminEmailTable = ({ columns }) => {
  const [data, setData] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [email_id, setEmailID] = useState('');
  const fileName = 'EmailInfo';
  const email_headers = [
    { label: 'Name', key: 'email_subject' },
    { label: 'Date', key: 'date_time' },
    { label: 'Email Documents', key: 'email_documents' }
  ];

  async function getData(ender) {
    await axios
      .get(config.apiURL + ender, {
        headers: {
          'Content-Type': 'application/json',
          token: config.getToken()
        }
      })
      .then((response) => {
        setData(response.data);
        setLoadingData(false);
      });
  }

  useEffect((loadingData) => {
    let all_end = '/emails/all';
    getData(all_end);

    if (loadingData) {
      //if the result is not ready so you make the axios call
      getData(all_end);
      setLoadingData(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const filterTypes = useMemo(
    () => ({
      // Add a new fuzzyTextFilterFn filter type.
      fuzzyText: fuzzyTextFilterFn,
      // Or, override the default text filter to use
      // "startWith"
      text: (rows, id, filterValue) => {
        return rows.filter((row) => {
          const rowValue = row.values[id];
          return rowValue !== undefined
            ? String(rowValue)
                .toLowerCase()
                .startsWith(String(filterValue).toLowerCase())
            : true;
        });
      }
    }),
    []
  );

  // Define a default UI for filtering
  function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter }
  }) {
    const count = preFilteredRows.length;

    return (
      <input
        value={filterValue || ''}
        onChange={(e) => {
          setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        }}
        placeholder={`Search ${count} records...`}
      />
    );
  }

  function fuzzyTextFilterFn(rows, id, filterValue) {
    return matchSorter(rows, filterValue, { keys: [(row) => row.values[id]] });
  }

  // Remove email
  function deleteEmailModal() {
    setShowModal(true);
  }

  async function handleRemoveEmail() {
    await axios
      .delete(config.apiURL + `/delete_email`, {
        headers: {
          'Content-Type': 'application/json',
          token: config.getToken()
        },
        data: { email_id: email_id }
      })
      .then((res) => {
        console.log(res);
        console.log(res.data);
        getData('/emails/all');
        alert(`Email id : ${email_id} has been removed`);
        setShowModal(false);
      });
  }

  // Let the table remove the filter if the string is empty
  fuzzyTextFilterFn.autoRemove = (val) => !val;

  const defaultColumn = useMemo(
    () => ({
      Filter: DefaultColumnFilter
    }),
    []
  );

  //Table Instance
  const tableInstance = useTable(
    {
      columns,
      data,
      defaultColumn, // Be sure to pass the defaultColumn option
      filterTypes,
      initialState: { pageIndex: 0 }
    },
    useFilters, // useFilters!
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        {
          id: 'deletion',
          Header: 'Delete',
          accessor: ['email_id'],
          disableFilters: true,
          filterable: false,
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (
            <div>
              <button
                className='btn'
                onClick={() => {
                  deleteEmailModal();
                  setEmailID(row.original.email_id);
                }}
                style={{ margin: '2px', width: '60px', fontSize: '10px' }}
              >
                Delete
              </button>
            </div>
          )
        },
        ...columns
      ]);
    }
  );

  //Set table variables
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    page, //Begins the pagination and select stuff
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    state: { pageIndex }
  } = tableInstance;

  return (
    <div style={{ flexGrow: '8', marginLeft: '10px', marginRight: '5px' }}>
      {loadingData ? (
        <p>Loading Please wait...</p>
      ) : (
        <table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render('Header')}
                    <div>
                      {column.canFilter ? column.render('Filter') : null}
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    if (cell.column.id === 's3_prefix') {
                      return (
                        <td {...cell.getCellProps()}>
                          <a
                            style={{ color: 'blue' }}
                            href={`/fileExplorer?s3_prefix=${cell.value}`}
                          >
                            View
                          </a>
                        </td>
                      );
                    } else {
                      return (
                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                      );
                    }
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
      <div>
        <Modal
          isOpen={showModal}
          contentLabel='remove email'
          onRequestClose={() => {
            setShowModal(false);
          }}
          shouldCloseOnOverlayClick={true}
          className='custom-modal'
          overlayClassName='custom-modal-overlay'
        >
          <center>
            <h2>Are you sure you want to delete email?</h2>
            <h3>
              <i>This is final.</i>
            </h3>
            <button
              style={{
                padding: '10px',
                margin: '10px',
                backgroundColor: 'lightgreen',
                borderRadius: '6px'
              }}
              onClick={handleRemoveEmail}
            >
              Yes
            </button>
            <button
              style={{
                padding: '10px',
                margin: '10px',
                width: '50px',
                backgroundColor: 'red',
                borderRadius: '6px'
              }}
              onClick={() => {
                setShowModal(false);
              }}
            >
              No
            </button>
          </center>
        </Modal>
      </div>
      <div className='pagination'>
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
          {'<<'}
        </button>
        <button onClick={() => previousPage()} disabled={!canPreviousPage}>
          {'<'}
        </button>
        <button onClick={() => nextPage()} disabled={!canNextPage}>
          {'>'}
        </button>
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
          {'>>'}
        </button>
        <span>
          Page
          <strong>
            {pageIndex + 1} of {pageOptions.length}
          </strong>
        </span>
        <span>
          | Go to page:
          <input
            type='number'
            defaultValue={pageIndex + 1}
            onChange={(e) => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0;
              gotoPage(page);
            }}
            style={{ width: '100px' }}
          />
        </span>
      </div>
      <DownloadButton
        new_data={rows}
        headers={email_headers}
        file={fileName}
        dataType='react-table'
      />
    </div>
  );
};
